import invariant from 'invariant';

import { configValue } from 'utils/config';

let stripeLoaded = false;
let stripeLoading = false;

const insertScript = () => {
  const publishableKey = configValue('stripe', 'publishableKey');
  invariant(publishableKey, 'Missing STRIPE_PUBLISHABLE_KEY');
  return new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = `https://js.stripe.com/v2/`;

    script.onload = () => {
      Stripe.setPublishableKey(publishableKey);
      // @ts-expect-error ts-migrate(2794) FIXME: Expected 1 arguments, but got 0. Did you forget to... Remove this comment to see the full error message
      resolve();
    };

    invariant(document.head, 'Missing document.head');
    document.head.appendChild(script);
  });
};

export default (): Promise<void> =>
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line consistent-return
  new Promise((resolve, reject) => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-promise-executor-return
    if (stripeLoaded) return resolve();

    if (stripeLoading) {
      let retries = 0;

      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line consistent-return
      (function waitForStripe() {
        if (stripeLoaded) return resolve();
        // retry for 3s
        if (retries > 100) return reject(new Error('Error loading Stripe'));
        retries += 1;
        setTimeout(waitForStripe, 30);
      })();

      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line consistent-return
      return;
    }

    stripeLoading = true;
    insertScript().then(() => {
      stripeLoading = false;
      stripeLoaded = true;
      resolve();
    });
  });
